import styled from "styled-components"

import {H3} from "@irati/ui/src/Typography/Heading"
import {minWidthMedia} from "@irati/ui/src/global/media"
import ellipsis from "@irati/ui/src/global/css/multiLineEllipsis"

export const Header = styled(H3)`
  padding: 20px 60px 20px 20px;
  ${ellipsis(1)}

  ${minWidthMedia.tablet`
    font-size: 18px;
    line-height: 21px;
  `}
`

export const LocationsMapWrapper = styled.div`
  height: calc(100vh - 60px);
`
